document.addEventListener('DOMContentLoaded', () => {
  const cartIcon = document.querySelector('a[href="/cart"]');
  if (!cartIcon) return;

  cartIcon.addEventListener('click', (e) => {
    const gems = ['💎'];
    
    for (let i = 0; i < 10; i++) {
      const gem = document.createElement('div');
      gem.classList.add('gem-particle');
      gem.textContent = gems[Math.floor(Math.random() * gems.length)];
      
      const rect = cartIcon.getBoundingClientRect();
      gem.style.left = rect.left + rect.width / 2 + 'px';
      gem.style.top = rect.top + rect.height / 2 + 'px';
      gem.style.setProperty('--tx', (Math.random() * 200 - 100) + 'px');
      gem.style.setProperty('--ty', (Math.random() * -150 - 50) + 'px');
      
      document.body.appendChild(gem);
      setTimeout(() => gem.remove(), 5000);
    }
  });
});